module.exports = __webpack_public_path__ + "img/img_07.821fc4b4.png";